import RelatedLinks from '@/components/related-links';

import useSpecialtyPageContext from '@/features/specialty-page/hooks/use-specialty-page-context';

export type SpecialtyRelatedLinksProps = {
  id: string;
};

export default function SpecialtyRelatedLinks(
  props: SpecialtyRelatedLinksProps
) {
  const { specialtyPageStaticData } = useSpecialtyPageContext();
  if (!specialtyPageStaticData) return null;

  const relatedLinksData = specialtyPageStaticData.relatedLinks[props.id];
  if (!relatedLinksData) return null;

  return <RelatedLinks title='Related content' links={relatedLinksData} />;
}
